export default {
    "MIME-Version": "1.0",
    "Content-Type": "text/plain; charset=utf-8",
    "Content-Transfer-Encoding": "8bit",
    "X-Generator": "Ideo Core",
    "PO-Revision-Date": "2025-01-16T18:28:34.737Z",
    "Last-Translator": "",
    "Language-Team": "",
    "Language": "en-US",
    "Messages": {
        "${str}": "",
        "Administracja": "Administration",
        "Akceptuj": "Accept",
        "Aktywne kanały komunikacji": "",
        "Anuluj": "",
        "Błąd w kodzie MJML.": "Error in MJML code.",
        "Brak nowych powiadomień.": "",
        "Centrum powiadomień": "Notification center",
        "Data otrzymania": "",
        "Data utworzenia": "Creation date",
        "Data wysłania": "Send date",
        "Dodaj szablon": "Add template",
        "Dodaj typ": "",
        "Dodaj wiadomość": "",
        "Dodaj zmienne dla szablonu": "Add variables for template",
        "Dodane przez": "Added by",
        "Edytowane mogą być tylko szablony włączonych i obsługiwanych kanałów.": "Only templates of enabled and supported channels can be edited.",
        "Edytuj": "Edit",
        "Edytuj szablon": "Edit template",
        "Edytuj typ": "",
        "Edytuj wiadomość": "",
        "Id": "Id",
        "ID": "ID",
        "Kanał jest domyślnie wymagany. Nie da się wyłączyć wysyłania powiadomienia tym kanałem. Możliwa jest tylko zmiana tytułu i treści komunikatu.": "Channel is required by default. It cannot be disabled for sending notifications via this channel. Only the title and content of the message can be changed.",
        "kanał wymagany": "",
        "Kanały": "Channels",
        "Kanały komunikacji": "Communication channels",
        "Kanały obsługiwane przez wybrany typ powiadmienia": "Channels supported by the selected notification type",
        "Kanały włączone w ustawieniach aplikacji": "Channels enabled in application settings",
        "Kategoria": "Category",
        "Klucze": "Keys",
        "Kod MJML": "MJML code",
        "Konfiguracja domyślna": "Default configuration",
        "Konfiguracja stopki oraz logo umieszczanych w wysyłanych powiadomieniach kanałem mailowym. Stopka może być skonfigurowana indywidualnie dla każdej wersji jezykowej, logo jest wspólne dla wszystkich.": "",
        "Kopiuj": "Copy",
        "Lista jest pusta": "List is empty",
        "Logo": "",
        "Moje dokumenty": "My documents",
        "Nazwa": "Name",
        "Nazwa powiadomienia": "Notification name",
        "Nazwa szablonu": "Template name",
        "Nazwa typu": "Type name",
        "Nazwa zmiennej nie może być pusta.": "Variable name cannot be empty.",
        "Nie udało się pobrać listy kanałów": "",
        "Nie udało się pobrać listy powiadomień": "",
        "Nie udało się pobrać powiadomień.": "",
        "Nie udało się wykonać akcji": "",
        "Nie znaleziono żadnych wyników.": "No results found.",
        "Odznacz": "",
        "Odznacz wszystkie": "",
        "Oznacz": "",
        "Oznacz jako nieprzeczytane": "",
        "Oznacz jako przeczytane": "",
        "Oznacz powiadomienia": "",
        "Oznacz wszystkie jako przeczytane": "",
        "Oznacz wybrane jako nieprzeczytane": "",
        "Oznacz wybrane jako przeczytane": "",
        "Poczta wychodząca": "",
        "Podgląd HTML": "HTML preview",
        "Podgląd szablonu": "Template preview",
        "Pokaż w koncie użytkownika": "Show in user account",
        "Potwierdzenie usunięcia": "Delete confirmation",
        "Potwierdź akceptację": "Confirm approval",
        "Powiadomienia": "",
        "Powiadomienia mailowe": "",
        "Powiadomienia zostały skonfigurowane.": "",
        "Powiadomienie jest domyślnie wymagane. Nie da się wyłączyć wysyłania tego powiadomienia.": "Notification is required by default. It cannot be disabled.",
        "Powiadomienie testowe zostało wysłane.": "",
        "Powiadomienie zbiorowe zostało dodane.": "Bulk notification has been added.",
        "Powiadomienie zbiorowe zostało zaktualizowane.": "Bulk notification has been updated.",
        "Powiększ kod MJML": "Expand MJML code",
        "Powiększ podgląd": "Zoom in preview",
        "Powrót": "Back",
        "Stan powiadomienia": "Notification state",
        "Status dokumentu został zmieniony.": "Document status has been changed.",
        "Status powiadomienia": "Notification status",
        "Stopka": "",
        "Strona główna": "",
        "System": "System",
        "System powiadomień": "",
        "Szablon został dodany.": "Template has been added.",
        "Szablon został usunięty.": "Template has been deleted.",
        "Szablon został zaktualizowany.": "Template has been updated.",
        "Szablony email": "",
        "Ten kanał ma możliwość wysyłania tekstu sformatowanego.": "This channel can send formatted text.",
        "Ten kanał nie ma możliwości wysyłania tekstu sformatowanego.": "This channel cannot send formatted text.",
        "Testuj": "",
        "Treść": "Content",
        "Typ powiadomienia": "Notification type",
        "Typy powiadomień": "",
        "Tytuł": "Title",
        "Tytuł powiadomienia": "Notification title",
        "Ustawienia": "",
        "Ustawienia powiadomień zostały zaktualizowane.": "",
        "Usuń": "Delete",
        "Wersje": "Versions",
        "Włączone": "Enabled",
        "Włączony": "",
        "Wpis do kalendarza został usunięty.": "Calendar entry has been deleted.",
        "Wszystko": "",
        "wybierz": "select",
        "Wybierz typ powiadomienia aby zobaczyć dostępne klucze.": "Select notification type to see available keys.",
        "wybierz...": "select...",
        "Wybór języka": "Language selection",
        "Wyłączony": "",
        "Wymagane": "Required",
        "Wystąpiły błędy w formularzu. Sprawdź wszystkie pola formularza.": "Errors in form. Check all form fields.",
        "Wysyłaj tym kanałem": "Send via this channel",
        "Wysyłka wiadomości": "",
        "Wyślij do": "Send to",
        "Zapisz": "Save",
        "Zapisz i wróć": "Save and back",
        "Zapisz ustawienia": "",
        "Zaznacz": "",
        "Zaznacz wszystkie": "",
        "Zmiana hasła": "",
        "Zmienne": "Variables",
        "Zobacz wszystkie": "",
        "Żaden kanał komunikacji nie został włączony w ustawieniach powiadomień.": "No communication channel has been enabled in notification settings."
    }
};
